import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { LabelCountry } from "@components"
import { WEBBACK_V2_API } from "@constants"
import { country, retailer } from "@signals"


export default function DIPSite({filters={}, ...props}) {
    const optionRetailer = useSignal([])
    const inputValue = useSignal("")

    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={`${WEBBACK_V2_API}/master-data/site/options`}
        filters={{ country: country.value, ...filters }}
        label="Retailers"
        placeholder="All Retailers"
        options={optionRetailer.value}
        value={retailer.value}
        filterOptions={(options, { inputValue }) => options.filter(op => {
            if (op.value === "select_all") return true
            return op.label.toLowerCase().includes(inputValue.toLowerCase())
        })}
        onInputChange={(_, newInputValue) => {
            if (newInputValue.length)
                inputValue.value = newInputValue
        }}
        onChange={e => {
            if (props.multiple !== false && e.target.value.includes("select_all")) {
                retailer.value = [...retailer.value, ...optionRetailer.value.filter(op => op.value !== "select_all")
                    .filter(op => op.label.toLowerCase().includes(inputValue.value.toLowerCase()))
                    .map(op => op.value)
                ]
            } else {
                retailer.value = e.target.value
            }
            inputValue.value = ""
        }}
        formatOptionLabel={({ label, country, value }) => {
            if (value === "select_all")
                return <Box borderBottom="1px solid" width={1}>
                    {label}
                </Box>
            return <LabelCountry country={country} label={label} />
        }}
        onFinishAjax={options => {
            optionRetailer.value = [
                ...props.multiple !== false ? [{label: "Select All", value: "select_all"}] : [],
                ...options
            ]

            // Drop selected retailers that are not actually selectable (not in the loaded
            // options, or hidden via excludeOptions). Otherwise the Autocomplete receives a
            // value with no matching option -> MUI "invalid value" warning + signals
            // hook-order crash in the dev build. Value items may be ids or option objects.
            const excluded = props.excludeOptions || []
            if (options.length && Array.isArray(retailer.value) && retailer.value.length) {
                const validIds = new Set(
                    options.map(op => op.value).filter(id => !excluded.includes(id))
                )
                const sanitized = retailer.value.filter(item => validIds.has(item?.value ?? item))
                if (sanitized.length !== retailer.value.length)
                    retailer.value = sanitized
            }
        }}
        {...props}
    />
}